import {Vue, Component} from 'vue-property-decorator'

@Component({
  components: {
    'vehicle-fleet-list': async () => import('../components/block-vehicle-fleet-list/BlockVehicleFleetList.vue')
  },
  filters: {}
})
class BlockVehicleFleet extends Vue {
  constructor () {
    super()
  }

  get lblSetting () {
    return {
      ...require('@/locales/block').default
    }
  }
}

export default BlockVehicleFleet



// WEBPACK FOOTER //
// ./src/containers/block/block-vehicle-fleet/index.ts